import {
  AgencyBasePackage,
  HgSupportedLanguage,
  TargetPlatform,
} from '@smg-real-estate/hg-search-libs';

export enum PriceDropAlertStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum PriceDropAlertSubscriptionType {
  EXPERT = 'Expert',
  PROFESSIONAL = 'Professional',
}

export enum PriceDropAlertSupportedChannel {
  IOS = 'IOS',
  ANDROID = 'ANDROID',
  EMAIL = 'EMAIL',
  UNKNOWN = 'UNKNOWN',
}

export enum PriceDropAlertAction {
  ACTIVATE_PRICE_DROP_ALERT = 'activatePriceDropAlert',
  DELETE_PRICE_DROP_ALERT = 'deletePriceDropAlert',
}

export interface PriceDropAlert {
  recipient: string;
  listingId: string;
  platform: TargetPlatform.HOMEGATE | TargetPlatform.IMMOSCOUT24;
  language: HgSupportedLanguage;
  status: PriceDropAlertStatus;
  price: number;
  name: string;
}

export interface CreatePriceDropAlertEmitPayload {
  name: string;
  recipient: string;
  listingId: string;
}

export const isPriceDropAlertSupportedBasePackage = (
  basePackage?: AgencyBasePackage | null,
): basePackage is AgencyBasePackage.RE_GOLD | AgencyBasePackage.RE_SILVER => {
  return basePackage === AgencyBasePackage.RE_GOLD || basePackage === AgencyBasePackage.RE_SILVER;
};

export interface CreatePriceDropAlertPayload {
  recipient: string;
  listingId: string;
  name: string;
  basePackage?: AgencyBasePackage;
  language: HgSupportedLanguage;
  price: number;
  channel: PriceDropAlertSupportedChannel;
}

export enum PriceDropAlertRequestStatus {
  NOT_SUBMITTED = 'NOT_SUBMITTED',
  PENDING = 'PENDING',
  FETCHED = 'FETCHED',
  ACTIVATED = 'ACTIVATED',
  DELETED = 'DELETED',
  CREATED = 'CREATED',
  ERROR = 'ERROR',
  NO_TOKEN_ERROR = 'NO_TOKEN_ERROR',
  NOT_FOUND_ERROR = 'NOT_FOUND_ERROR',
  ALREADY_EXISTS_ERROR = 'ALREADY_EXISTS_ERROR',
}
